enum MaturityAction1ProductSelectionType {
    ThisNewProduct = "THIS_NEW_PRODUCT",
    DifferentProduct = "DIFFERENT_PRODUCT"
}
export default MaturityAction1ProductSelectionType